export class FormValidation {
  constructor(node) {
    this.formField = node;
  }

  /**
   * Initializes elements needed to dynamically parse form field validation messages for on-the-fly form-validation
   * *Ideally* on-the-fly form field validation happens after one leaves the current field (*(on)blur*) and not as they are still typing into it, but you do you of course.
   *
   * Also: This happens on the client, do not forget to implement serverside validation as well (if that hasn't happened yet)
   *
   * @param fieldState State the field is in. Either `success` or `error`
   * @param fieldMessage (Optional) Error message text. *Ideally* this is coming as translated string from TYPO3 via Localize function, so you get fitting text bits for the current active language.
   */
  formValidationMessage(fieldState, fieldMessage = '') {

    const formValidationMessageWrapper = document.createElement('span');
    formValidationMessageWrapper.classList.add('c-form-validation');
    formValidationMessageWrapper.classList.add(`c-form-validation--state-${fieldState}`);

    const formValidationIcon = document.createElement('i');
    const bootStrapIcon = (fieldState === 'success') ? 'check' : 'x';
    formValidationIcon.classList.add('c-form-validation__icon');
    formValidationIcon.classList.add('bi');
    formValidationIcon.classList.add(`bi-${bootStrapIcon}-circle-fill`);

    if (fieldMessage !== '') {
      const formValidationMessageElement = document.createElement('span');
      formValidationMessageElement.classList.add('c-form-validation__message');
      formValidationMessageElement.textContent = fieldMessage;

      formValidationMessageWrapper.insertAdjacentElement('afterbegin', formValidationMessageElement);
      formValidationMessageWrapper.insertAdjacentElement('beforeend', formValidationIcon);
      if (this.formField.closest('.c-form-group ').querySelector('.c-form-validation')) {
        this.formField.closest('.c-form-group ').querySelector('.c-form-validation').remove();
      }
    } else {
      if (this.formField.closest('.c-form-group ').querySelector('.c-form-validation')) {
        this.formField.closest('.c-form-group ').querySelector('.c-form-validation').remove();
      }
      formValidationMessageWrapper.insertAdjacentElement('beforeend', formValidationIcon);
    }

    return formValidationMessageWrapper;
  }

  /**
   * Apply custom validity messages to the field, in case the Browser defined messages are not sufficient.
   *
   * @param fieldType The type of field to validate against, e.g. select, input
   * @param validityMessage Error message text. *Ideally* this is coming as translated string from TYPO3 via Localize function, so you get fitting text bits for the current active language.
   */
  customValidity(fieldType, validityMessage) {

    if (fieldType === 'select') {
      if (this.formField.selectedIndex > 0) {
        this.formField.setCustomValidity('');

        // Mitigate a Chromium bug where Validity messages are not triggered when `scroll-behaviour` is set to `smooth` as well by temporarily unsetting smooth behaviour for this.
        // @see: https://issues.chromium.org/issues/40196176
        // Also, yes, due to UA spoofing this is not very reliable, but should suffice in the meantime until they fix this (issue seems to be actively worked on),
        // people in the ticket report this may be fixed by moving to anchor positioning, which could be explored as well, but this then also needs a fallback, considering the feature not even baseline yet, see: https://caniuse.com/mdn-css_properties_anchor-name
        if (navigator.userAgent.includes('Chrome')) {
          document.querySelector('html').style.scrollBehavior = 'auto';
        }
      } else {
        this.formField.setCustomValidity(validityMessage);
        if (navigator.userAgent.includes('Chrome')) {
          document.querySelector('html').style.scrollBehavior = 'auto';
        }
      }
    } else {
      if (this.formField.validity.valueMissing) {
        this.formField.setCustomValidity(validityMessage);
      } else {
        if (this.formField.validity.patternMismatch) {
          this.formField.setCustomValidity(validityMessage);
        } else {
          this.formField.setCustomValidity('');
        }
      }
    }
  }
}
